import { getProductJson } from '../product-page/helpers';

const storage_name = 'wild-recently-views-products';

const extractRecentlyViewedProducts = () => {
  // let cookie_values = Cookies.get(storage_name);
  let cookie_values = window.localStorage.getItem(storage_name);
  if (typeof cookie_values === 'undefined') {
    cookie_values = [];
  }

  let products_json = JSON.parse(cookie_values);

  if ($('[data-product-json]').length) {
    const product = getProductJson();
    
    // Remove current product from returned recent products
    _.remove(products_json, (recent_product) => {
      return recent_product.handle === product.handle;
    });

    products_json = _.reverse(products_json);
  }

  return products_json;
};

const saveRecentlyViewedCookie = () => {
  if (!$('[data-product-json]').length) {
    return;
  }

  const product = getProductJson();

  let cookie_values = window.localStorage.getItem(storage_name);
  // console.log('cookie_values', cookie_values);

  if (cookie_values === null || !cookie_values.length) {
    cookie_values = [];
  }

  if (cookie_values.length) {
    cookie_values = JSON.parse(cookie_values);
  }

  // In case the cookie has been altered for some reasons
  if (!Array.isArray(cookie_values)) {
    cookie_values = [];
  }

  // Do not add if product is already in history
  if (_.find(cookie_values, {handle: product.handle})) {
    return;
  }

  // We reached the max products allowed, make room by removing the oldest one
  if (cookie_values.length >= Number($('[data-recently-viewed-products-slider]').data('recently-viewed-products-max'))) {
    cookie_values.splice(0, 1);
  }

  cookie_values.push({
    title: product.title,
    handle: product.handle,
    featured_image: product.featured_image,
    price: product.price,
    price_min: product.price_min,
    price_max: product.price_max,
    compare_at_price: product.compare_at_price,
  });

  // Cookies.set(storage_name, cookie_values);
  window.localStorage.setItem(storage_name, JSON.stringify(cookie_values));
};

export { saveRecentlyViewedCookie, extractRecentlyViewedProducts };
